enum ForecasterControlSection {
  DoohAdFormat = 'doohAdFormat',
  DoohVenueType = 'doohVenueType',

  Audience = 'audience',
  Products = 'products',
  Duration = 'duration',
  DealGroups = 'dealGroups',

  GamVideoPosition = 'gamVideoPosition',
  GamCreativeSize = 'gamCreativeSize',
}

export default ForecasterControlSection;
